import React from 'react';

const Cookie = () => {
  return (
    <div className="min-h-screen pt-32 md:pt-36">
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="display-large mb-8">Cookie Policy</h1>
            <div className="space-y-6 body-medium">
              <p className="body-large text-[#2D6A4F]">
                Effective Date: October 17, 2024
              </p>

              <div>
                <h2 className="heading-2 mb-4">1. What Are Cookies</h2>
                <p>
                  Cookies are small text files stored on your device when you visit our website. 
                  They help us provide you with a better experience by remembering your preferences 
                  and understanding how you use our site.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">2. How We Use Cookies</h2>
                <p className="mb-3">FITNOVEXA uses cookies to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Keep you signed in to your account</li>
                  <li>Remember your preferences and settings</li>
                  <li>Understand how you interact with our website</li>
                  <li>Improve our services and user experience</li>
                  <li>Analyze website traffic and performance</li>
                </ul>
              </div>

              <div>
                <h2 className="heading-2 mb-4">3. Types of Cookies We Use</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="heading-3 mb-2">Essential Cookies</h3>
                    <p>Required for the website to function properly. These cannot be disabled.</p>
                  </div>
                  <div>
                    <h3 className="heading-3 mb-2">Performance Cookies</h3>
                    <p>Help us understand how visitors use our website by collecting anonymous information.</p>
                  </div>
                  <div>
                    <h3 className="heading-3 mb-2">Functionality Cookies</h3>
                    <p>Remember your preferences and provide enhanced features.</p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="heading-2 mb-4">4. Third-Party Cookies</h2>
                <p>
                  We may use third-party services that set cookies on our behalf for analytics 
                  and functionality purposes. These third parties have their own privacy policies 
                  governing cookie use.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">5. Managing Cookies</h2>
                <p className="mb-3">
                  You can control cookies through your browser settings. Most browsers allow you to:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>View and delete cookies</li>
                  <li>Block all cookies</li>
                  <li>Allow only certain cookies</li>
                  <li>Delete cookies when closing your browser</li>
                </ul>
                <p className="mt-4">
                  Note: Disabling cookies may affect website functionality and your user experience.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">6. Changes to This Policy</h2>
                <p>
                  We may update this Cookie Policy periodically. Changes will be posted on this page 
                  with an updated effective date.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">7. Contact Us</h2>
                <p>
                  Questions about our Cookie Policy? Contact us at:<br />
                  Email: info@fitnovexa.com<br />
                  Phone: (202) 505-4544<br />
                  Website: fitnovexa.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cookie;
